import {useContext} from 'react';
import PerformanceMonitorTrackStartSelfContext from 'src/internal/provider/PerformanceMonitorTrackStartSelfContext';

import type {PerformanceMonitorTrackStart} from 'src/types';

export default function usePerformanceMonitorTrackStart(): PerformanceMonitorTrackStart {
  return useContext(PerformanceMonitorTrackStartSelfContext);
}
